"use client";

import Image from "next/image";

const FilterBlock = ({
  categories,
  filter,
  setFilter,
  keyword,
  setKeyword,
  searchPlaceHolder,
  locale,
}: any) => {
  const inActiveButtonClass =
    "px-4 py-[6px] rounded-md capitalize text-[#5a558e] shadow-sm bg-transparent border border-[#5a558e]";

  const activeButtonClass =
    "px-4 py-[6px] rounded-md capitalize text-[#5a558e] shadow-sm bg-[#5a558e] text-white border border-[#5a558e]";

  return (
    <div className="container mx-auto px-5 grid grid-cols-1 md:grid-cols-[1fr_400px] gap-4">
      <div className="flex items-center justify-start gap-4">
        <button
          className={filter === "All" ? activeButtonClass : inActiveButtonClass}
          onClick={(e) => setFilter("All")}
        >
          {locale === "en" ? "All" : "الجميع"}
        </button>
        {categories?.map((cat: any, index: number) => {
          return (
            <button
              key={index}
              className={
                filter === cat?.attributes?.name
                  ? activeButtonClass
                  : inActiveButtonClass
              }
              onClick={(e) => setFilter(cat?.attributes?.name)}
            >
              {cat?.attributes?.name}
            </button>
          );
        })}
      </div>
      <div>
        <div className="flex items-center justify-start border border-gray-500 py-2 px-4 rounded-md shadow-sm w-full md:w-[300px] md:ltr:ml-auto md:rtl:mr-auto md:focus-within:w-full duration-300 ease-linear">
          <input
            type="text"
            placeholder={searchPlaceHolder}
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            className="flex-1 bg-transparent focus:outline-none text-[#6b6b6b]"
          />
          <div className="relative w-6 h-6">
            <Image src="/assets/icons/search.svg" alt="search Icon" fill />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBlock;
